import * as Yup from "yup";

const TRANSLATION_BASE_PATH = "_MAIN._SETTINGS._MY_PROFILE";

export const formValidator = (translate: (key: string) => string) =>
	Yup.object({
		profilePicture: Yup.string()
			.trim()
			.required(translate(`${TRANSLATION_BASE_PATH}._REQUIRED`))
	});
